<template>
    <div>
        <div class="menu-title">
            微信卡片管理
        </div>
        <div class="menu-content">
            <div>
                <el-form :inline="true" :model="qo" size="small" class="demo-form-inline">
                    <el-form-item label="标题：">
                        <el-input v-model="qo.LIKES_title" placeholder="请输入标题" style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%">
                    <el-table-column type="index" label="序号" width="100"></el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="mediaType" label="媒体类型" width="80">
                        <template slot-scope="scope">
                            {{ scope.row.mediaType === 'image' ? '图片' : '缩略图' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="purpose" label="用途" width="180">
                        <template slot-scope="scope">
                            {{ purposeLabel(scope.row.purpose) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="imgPath" label="图片" width="120">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.imgPath != null && scope.row.imgPath.length > 0"
                                      style="width: 70px; height: 70px;background-color: #b0b4b9;"
                                      :src="path + scope.row.imgPath"
                                      :preview-src-list="[path + scope.row.imgPath]"
                                      fit="contain"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weChartImgId" label="微信素材ID" width="280">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.weChartImgId" placement="top" v-if="scope.row.weChartImgId && scope.row.weChartImgId.length > 30">
                                <span>{{ scope.row.weChartImgId.substring(0, 30) + '...' }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.weChartImgId }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weChartUrl" label="微信URL" min-width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.weChartUrl" placement="top" v-if="scope.row.weChartUrl && scope.row.weChartUrl.length > 40">
                                <span>{{ scope.row.weChartUrl.substring(0, 40) + '...' }}</span>
                            </el-tooltip>
                            <span v-else>{{ scope.row.weChartUrl }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="modifyRow(scope.row)" type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)" type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]"
                               @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                   :title="dialogName"
                   :visible.sync="cmdDialogVisible"
                   width="40%">
            <el-form ref="cmd" label-width="100px" :rules="rules" :model="cmd">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="cmd.title" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="媒体类型" prop="mediaType">
                    <el-select v-model="cmd.mediaType" placeholder="请选择媒体类型" style="width: 100%">
                        <el-option label="图片" value="image"></el-option>
                        <el-option label="缩略图" value="thumb"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用途" prop="purpose">
                    <el-select v-model="cmd.purpose" placeholder="请选择用途" style="width: 100%">
                        <el-option label="关注公众号推送对应小程序" value="eventSubscribe"></el-option>
                        <el-option label="其他" value="other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片" prop="imgPath">
                    <el-upload
                            class="avatar-uploader"
                            action="#"
                            accept="image/jpeg,image/png"
                            :on-change="handleFileChange"
                            :auto-upload="false"
                            :show-file-list="false">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request, {getFileUrl} from '@/utils/request';

var _this;
export default {
    name: "wechatCardManage",
    data() {
        return {
            qo: {
                pageNo: 1,
                pageSize: 10,
                LIKES_title: '',
                DESCI_createTime: 1
            },
            result: {
                records: [],
                total: 0
            },
            dialogName: '编辑',
            cmdDialogVisible: false,
            cmd: {},
            rules: {
                title: [
                    {required: true, message: '请输入标题'}
                ],
                mediaType: [
                    {required: true, message: '请选择媒体类型'}
                ],
                purpose: [
                    {required: true, message: '请选择用途'}
                ],
                imgPath: [
                    {required: true, message: '请上传图片'}
                ]
            },
            imageUrl: "",
            path: getFileUrl()
        }
    },
    mounted() {
        _this = this;
        _this.queryData();
    },
    methods: {
        purposeLabel(val) {
            const map = {
                'eventSubscribe': '关注公众号推送对应小程序',
                'other': '其他'
            };
            return map[val] || val;
        },
        queryData() {
            request({
                url: '/core/wechart-card/query_pages',
                method: 'post',
                data: _this.qo
            }).then(res => {
                _this.result.records = res.records;
                _this.result.total = res.total;
            });
        },
        handleCurrentChange(val) {
            _this.qo.pageNo = val;
            _this.queryData();
        },
        handleSizeChange(val) {
            _this.qo.pageNo = 1;
            _this.qo.pageSize = val;
            _this.queryData();
        },
        removeRow(item) {
            _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request({
                    url: '/core/wechart-card/remove/' + item.id,
                    method: 'post'
                }).then(res => {
                    _this.$message.success("删除成功");
                    _this.queryData();
                });
            }).catch(() => {
            });
        },
        createRow() {
            _this.dialogName = '添加';
            _this.imageUrl = "";
            _this.cmdDialogVisible = true;
            _this.$nextTick(() => {
                _this.cmd = {
                    title: "",
                    mediaType: "",
                    purpose: "",
                    imgPath: ""
                };
                _this.$refs.cmd.resetFields();
            });
        },
        modifyRow(item) {
            _this.dialogName = '编辑';
            _this.imageUrl = "";
            _this.cmdDialogVisible = true;
            _this.$nextTick(() => {
                if (item.imgPath) {
                    _this.imageUrl = _this.path + item.imgPath;
                } else {
                    _this.imageUrl = "";
                }
                _this.cmd = JSON.parse(JSON.stringify(item));
                _this.$refs.cmd.resetFields();
            });
        },
        submitModify() {
            this.$refs.cmd.validate((valid) => {
                if (valid) {
                    if (_this.cmd.id && _this.cmd.id.toString().length > 0) {
                        request({
                            url: '/core/wechart-card/modify',
                            method: 'post',
                            data: _this.cmd
                        }).then(res => {
                            _this.$message.success("编辑成功");
                            _this.cmdDialogVisible = false;
                            _this.queryData();
                        });
                    } else {
                        request({
                            url: '/core/wechart-card/create',
                            method: 'post',
                            data: _this.cmd
                        }).then(res => {
                            _this.$message.success("添加成功");
                            _this.cmdDialogVisible = false;
                            _this.queryData();
                        });
                    }
                }
            });
        },
        handleFileChange(file, fileList) {
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (allowedTypes.indexOf(file.raw.type) < 0) {
                this.$message.error('仅支持上传 jpg/png 格式的图片');
                return;
            }
            this.imageUrl = URL.createObjectURL(file.raw);
            let formData = new FormData();
            formData.append("file", file.raw);
            request({
                url: '/upload/file/general',
                method: 'post',
                data: formData
            }).then(res => {
                _this.cmd.imgPath = res;
            });
        }
    }
}
</script>

<style lang="scss">
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
